// Centralised route helpers — use these instead of raw string literals throughout the app.
// Prevents silent typos and makes refactoring routes a single-file change.

export const ROUTES = {
  home: "/movflix/",
  catalogue: "/movflix/catalogue",
  discover: (contentType: string, category: string) =>
    `/movflix/discover/${contentType}?category=${category}`,
  content: (contentType: string, id: number, title: string) =>
    `/movflix/page?content_type=${contentType}&id=${id}&title=${encodeURIComponent(title)}`,
  person: (id: number) => `/movflix/person?id=${id}`,
  cast: (contentType: string, id: number, title: string) =>
    `/movflix/cast_crew?content_type=${contentType}&id=${id}&title=${encodeURIComponent(title)}`,
  seasons: (id: number) => `/movflix/seasons?id=${id}`,
  episodes: (showId: number, seasonNumber: number) =>
    `/movflix/episodes?id=${showId}&season_id=${seasonNumber}`,
  collection: (id: number) => `/movflix/collection?id=${id}`,
  search: (query: string) => `/movflix/search?q=${encodeURIComponent(query)}`,
  recommendations: (movieId?: number, contentType?: string, title?: string) =>
    movieId
      ? `/movflix/recommendations?movieId=${movieId}&contentType=${contentType ?? "movie"}&title=${encodeURIComponent(title ?? "")}`
      : "/movflix/recommendations",
  lists: (type: "favorites" | "watchlist" | "watched") => `/movflix/lists?type=${type}`,
  profile: "/movflix/profile",
  settings: "/movflix/settings",
  login: "/movflix/login",
  about: "/movflix/about",
  swipe: "/movflix/swipe",
  anime: (category?: string) =>
    category ? `/movflix/anime?category=${category}` : "/movflix/anime",
} as const;
